/**
 * Remove all unwanted characters except the ones from an URL.
 *
 * @param {String} text  The text to be sanited.
 *
 * @return {String}
 */
const url = (text) => text.replace(/[^-A-Za-z0-9+&@#/%?=~_|!:,.;\(\)]/g, '');

/**
 * Try to parse the input as a number, if it fails, it returns 0.
 *
 * @param {String} text  The text to be sanited.
 *
 * @return {Number}
 */
const number = (text) => {
  const asNumber = Number(text);
  return Number.isNaN(asNumber) ? 0 : asNumber;
};

/**
 * Remove all unwanted characters except hyphens, underscores, letters and numbers.
 *
 * @param {String} text  The text to be sanited.
 *
 * @return {String}
 */
const string = (text) => text.replace(/[^-_\w\d]/g, '');

/**
 * Check if the input is a `true` string.
 *
 * @param {String} text  The text to be sanited.
 *
 * @return {Boolean}
 */
const boolean = (text) => `${text}` === 'true';

export {
  url,
  number,
  string,
  boolean,
};
